// extracted by mini-css-extract-plugin
module.exports = {"star_header":"StarHeaderCell_star_header__1XQhF","icon":"StarHeaderCell_icon__2kO0S"};